module.exports = __webpack_public_path__ + "files/344e8cff9d7f97e3164b5088b1cbaa9c.png";